/**
 * 将文档中的 Markdown 加粗语法 **text** 转为 HTML <strong>
 */
export function formatRichText(text) {
  if (!text) {
    return '';
  }

  return String(text)
    .replace(/\\([.!?])/g, '$1')
    .replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" class="content-link">$1</a>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
}
